import type { ChatType, FeedType } from '@kanbu/schema';
import { Agent } from '@kanbu/schema/enums';

import { trpc } from '@/services/trpc';

export type FeedAgent = { id: string; name: string };

/**
 * The agents a feed is assigned to. Names are present only when the query
 * populated `chats`; otherwise the id stands in.
 */
export function getFeedAgents(feed: Pick<FeedType, 'chats'>): FeedAgent[] {
  const chats: Array<string | ChatType> = feed.chats ?? [];

  return chats.map(chat =>
    typeof chat === 'string'
      ? { id: chat, name: chat }
      : { id: chat.id, name: chat.name },
  );
}

/**
 * Only shop assistants search product feeds, so they are the only agents a
 * feed can be assigned to.
 */
export function useShopAgents(enabled = true) {
  return trpc.chats.findAll.useQuery(
    {
      where: { agent: Agent.ShopAssistant },
      fields: ['id', 'name'],
      pagination: { pageSize: 100 },
    },
    { enabled },
  );
}
